import Call from '../../Call.v2';
import { objToQs } from '../../Utils';

const apkInstallations = {
    get(filters) {
        return Call(`peerclick/apkInstallations?${objToQs(filters)}`);
    },
    // update(id, data) {
    //     return Call(`peerclick/conversions/cutoff/${id}`, "PUT", data);
    // },
    delete(deviceId) {
        return Call(`peerclick/apkInstallations/${deviceId}`, "DELETE");
    },
};

export default apkInstallations;



// WEBPACK FOOTER //
// ./src/services/API/components/peerclick/apkInstallations.js